<div class="tw-flex tw-flex-col tw-gap-4 tw-bg-color-surface-card">
  <div class="tw-flex tw-flex-wrap tw-gap-2">
    @for (filterOption of filterOptions; track filterOption) {
      <button
        type="button"
        (click)="setFilter(filterOption)"
        class="tw-flex tw-items-center tw-justify-center tw-py-2 tw-rounded-full tw-text-sm tw-font-medium tw-transition-all tw-text-dt-text-headings"
        [ngClass]="[
          filterOption === 'all' ? 'tw-w-[60px]' : 'tw-w-[97px]',
          selectedFilter() === filterOption
            ? 'tw-bg-color-surface-elevated tw-shadow-card-button'
            : 'tw-bg-color-surface-sunken',
        ]"
      >
        {{ filterOption | i18n }}
      </button>
    }
  </div>

  <!-- Entrance motion target (rows cascade in, height eases) — see RecentActivityComponent.playEntrance -->
  <div #activityBody>
    @if (!filteredItems().length) {
      <div class="tw-text-center tw-py-8">
        <p class="tw-text-[14px] tw-text-dt-text-secondary">
          {{ "noRecentActivity" | i18n }}
        </p>
      </div>
    } @else {
      <app-gloss-scroll class="-tw-mx-2 -tw-my-2" [rows]="4" [label]="'recentActivity' | i18n">
        <div
          class="tw-flex tw-flex-col tw-gap-3 tw-py-2 tw-ps-2 tw-pe-3"
          [class.tw-opacity-0]="entrancePending()"
        >
          @for (item of filteredItems(); track item.tag + "-" + item.id) {
            <div
              data-activity-row
              data-gs-row
              class="tw-flex tw-items-center tw-justify-between tw-px-6 tw-py-4 sm:tw-px-4 sm:tw-py-4 tw-gap-2 tw-rounded-2xl tw-overflow-hidden tw-bg-color-surface-card tw-shadow-list"
            >
              <!-- Left: icon + title/date -->
              <div class="tw-flex tw-items-center tw-gap-3">
                <div
                  class="tw-flex tw-justify-center tw-w-9 tw-h-9 tw-rounded-lg tw-flex-none"
                  [ngClass]="item.chipClass"
                >
                  <icon [size]="6" [name]="item.icon" [currentColor]="item.iconColor"></icon>
                </div>

                <div class="tw-flex tw-flex-col tw-gap-2">
                  <span
                    class="tw-font-semibold tw-text-[13px] tw-leading-[125%] tw-tracking-normal tw-text-dt-text-headings"
                  >
                    {{ item.title | i18n }}
                  </span>
                  <!-- No line at all for a row with no date, rather than an empty one. -->
                  @if (item.formattedDate) {
                    <span
                      class="tw-font-medium tw-text-[13px] tw-leading-[100%] tw-tracking-normal tw-text-color-text-tertiary"
                    >
                      {{ item.formattedDate }}
                    </span>
                  }
                </div>
              </div>

              <!-- Right: amount + category -->
              <div class="tw-flex tw-flex-col tw-items-end tw-gap-1 tw-flex-shrink-0">
                <span
                  class="tw-flex tw-justify-end tw-items-center tw-gap-1"
                  [ngClass]="
                    item.amount < 0 ? 'tw-text-color-money-out-text' : 'tw-text-color-money-in-text'
                  "
                >
                  <span class="tw-font-semibold tw-text-[16px] tw-leading-[100%] tw-tracking-normal"
                    >{{ item.amount >= 0 ? "+" : "" }}{{ item.amount | macroNumber }}</span
                  >
                  <span
                    class="tw-font-medium tw-text-[12px] tw-leading-[100%] tw-tracking-normal"
                    >{{ item.unit }}</span
                  >
                </span>
                <span class="tw-text-[13px] tw-leading-[125%] tw-text-dt-text-secondary">
                  {{ item.categoryLabel | i18n }}
                </span>
              </div>
            </div>
          }
        </div>
      </app-gloss-scroll>
    }
  </div>
</div>
